import { Intersection } from 'three/src/core/Raycaster';
import { Event, Object3D } from 'three';
import { itemDataApi } from '@/Interfaces/api';
import { $ } from '@/Engine/stateInstance';
import { tempBoxDataTemplate } from '@/Constants/demo';
import { addBox } from '@/Engine/addBox';

export const onFloorIntersection = async(
    floorIntersection: Intersection<Object3D<Event>>,
    data: { data: itemDataApi; category: any; }) => {
    const position = floorIntersection.point;
    if (data.data.name === 'Куб') {
        $.tempBoxData = { ...tempBoxDataTemplate, position: [ position.x, position.y, position.z ] };
        const box = addBox($.tempBoxData);
        // if ($.checkCollision(box, '')) {
        //
        //     box.model.removeFromParent();
        // }
        return;
    }
};

